import TripPackageSet from '@itinerary/trip/TripPackageSet';
import { TrainPackageLoader } from '@itinerary/trip/train/TrainPackageLoader';
import { type TrainPackageLoaderConfig } from '@itinerary/trip/train/types';
import type TrainPackage from '@itinerary/trip/train/TrainPackage';
import type TrainTourPackage from '@itinerary/trip/train/TrainTourPackage';
import {
    type TrainFilterData,
    type TrainFilters,
} from '@itinerary/trip/train/TrainModuleTypes';
import { type GetAvailableStatus } from '@clients/TrainApi';

export default class TrainPackageSet extends TripPackageSet<
    TrainFilterData,
    TrainFilters,
    TrainPackage | TrainTourPackage
> {
    override loader: TrainPackageLoader;
    protected override _list: (TrainPackage | TrainTourPackage)[] = [];

    protected override reset(
        config: TrainPackageLoaderConfig,
        filters: Record<TrainFilters, any>,
        minPrice?: number
    ) {
        super.reset(config, filters, minPrice);
        this.loader = new TrainPackageLoader(config);
    }

    get adultCount() {
        return this.loader.adultCount;
    }

    get childCount() {
        return this.loader.childCount;
    }

    get infantCount() {
        return this.loader.infantCount;
    }

    get availableStatus() {
        return this.loader.availableStatus;
    }

    set availableStatus(status: GetAvailableStatus) {
        this.loader.availableStatus = status;
    }

    get selectedCapacityId() {
        return this.loader.selectedCapacityId;
    }

    set selectedCapacityId(capacityId: number | undefined) {
        this.loader.selectedCapacityId = capacityId;
    }

    constructor(
        config: TrainPackageLoaderConfig,
        /**
         * Contains filters that must be applied to the results
         */
        public override filters: Record<TrainFilters, any>,

        /**
         * Minimum price that is obtained or expected from the current package set
         */
        public override minPrice?: number,

        public override isSuggestion = false
    ) {
        super(filters, minPrice);
        this.loader = new TrainPackageLoader(config);
    }
}
